import React from 'react';
import Avatar from '../../../Utility/Avatar';
import { ChatMessageRole } from '../../../../Types/Enums';
import CheckIcon from '../../../Utility/CheckIcon';

interface ConnectorItemProps {
    image: any;
    title: string;
    identifier?: string;
    handleChangeFunction?: any;
    isActive: boolean;
    useAvatar?: boolean;
}

function ConnectorItem({
    image,
    title,
    identifier,
    handleChangeFunction,
    isActive,
    useAvatar = false,
}: ConnectorItemProps) {
    return (
        <div
            onClick={() => {
                handleChangeFunction(identifier);
            }}
            className={`group relative border-2 hover:border-primary w-full overflow-hidden rounded-xl h-[80px] flex items-center cursor-pointer ${
                isActive ? 'border-primary' : 'border-layout-borderColor'
            }`}
        >
            <div className="h-[56px] w-[56px] bg-config-boxBackgroundColor p-2">
                {image ? (
                    <img
                        src={image}
                        className={`h-full w-full border-0 outline-0 object-cover ${useAvatar ? ' rounded-full' : ''}`}
                        alt=""
                    />
                ) : (
                    <div
                        className={`flex items-center justify-center h-full w-full ${
                            isActive ? 'opacity-100' : 'opacity-100'
                        }`}
                    >
                        <Avatar size={40} title={title} role={ChatMessageRole.assistant} position="relative" />
                    </div>
                )}
            </div>
            <div className="max-w-[calc(100%-56px)] w-full pl-2 pr-8">{title}</div>
            {isActive && <CheckIcon />}
        </div>
    );
}

export default ConnectorItem;
